export { default as MediaCollectionPlayer } from './MediaCollectionPlayer';
